import React, { useState, useEffect, useRef } from 'react';
import { useInViewport } from 'react-in-viewport';
import 'animate.css/animate.css';

const AnimationContainer = ({ animation, delay = 0, id, height, children }) => {
  const ref = useRef(null);

  const { inViewport } = useInViewport(
    ref,
    {
      rootMargin: '0px',
    },
    {
      disconnectOnLeave: true,
    },
    {
      triggerOnce: true,
    }
  );

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!inViewport) return;

    const timer = setTimeout(() => {
      setVisible(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [inViewport, delay]);

  return (
    <div
      ref={ref}
      id={id}
      className={visible ? `animate__animated animate__${animation}` : ''}
      style={{
        opacity: visible ? 1 : 0,
        height: height || 'auto',
      }}
    >
      {children}
    </div>
  );
};

export default AnimationContainer;
